
export default {
    props: {
        content: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        bgImage() {
            return process.browser ? (window.innerWidth > 576 ? this.content.image : this.content.mobileImage || this.content.image) : this.content.image
        },
    },
}
